import React, { Component } from 'react';
import './PaymentSelection.scss';
import paymentTypeService from '../../services/paymentTypeService';
import PaymentSelectionTile from './PaymentSelectionTile/PaymentSelectionTile';
import languageService from '../../services/languageService';
import ApplePayButton from '../PayButtons/ApplePayButton/ApplePayButton';
import GooglePayButton from '@google-pay/button-react/dist/index.es5.min.js';
import parameterService from "../../services/parameterService";
import paymentService from '../../services/paymentService';
const paymentTypes = paymentTypeService.getPaymentTypes();

class PaymentSelection extends Component {
    constructor(props) {
        super(props);
        this.onPaymentSelection = props.onPaymentSelection;
        this.state = {
            environment: parameterService.getGooglePayEnvironment(),
            paymentTypes: paymentTypes,
            selectedPayment: null,
            canMakeGooglePayments: false,
        };

        try {
            this.canMakeApplePayPayments = window.ApplePaySession && window.ApplePaySession.canMakePayments();
        } catch(error) {
            this.canMakeApplePayPayments = false;
        }
    }

    setSelectedPayment = selectedPayment => {
        this.setState({
            selectedPayment: selectedPayment
        });
    };

    onLoadPaymentData = paymentData => {
        paymentService.onLoadGooglePaymentData(paymentData)
    }

    onReadyToPayChange = data => {
        this.setState({
            canMakeGooglePayments: data.isButtonVisible
        });
    };

    onNextClick = event => {
        if (!(typeof this.state.selectedPayment === 'string' && this.state.selectedPayment.length)) {
            return;
        }
        this.onPaymentSelection(this.state.selectedPayment);
    };

    render() {
        return (
            <div className="row PaymentSelection">
                <div className="col-12">
                    <h2 className="m-4 text-center">
                        {languageService.texts.pleaseSelectMethod}
                    </h2>
                </div>
                <div className="col-12">
                    <div className="d-flex justify-content-center align-content-center flex-wrap">
                        {this.state.paymentTypes.map(payment => {
                            if (
                                (payment.type === 'googlepay' && !this.state.canMakeGooglePayments) ||
                                (payment.type === 'applepay' && !this.canMakeApplePayPayments)
                            ) {
                                return false;
                            }

                            return (
                                <PaymentSelectionTile
                                    paymentType={payment}
                                    key={payment.type}
                                    onPaymentSelection={this.setSelectedPayment}
                                    isFocused={this.state.selectedPayment === payment.type}
                                />
                            )
                        })}
                    </div>
                </div>
                <div className="col-12">
                    <div className="text-right m-4">
                        {(this.state.selectedPayment === 'applepay') && <ApplePayButton
                            buttonColor="black"
                            buttonLocale={languageService.selected}
                        />
                        ||
                        <GooglePayButton
                            environment={this.state.environment}
                            buttonLocale={languageService.selected}
                            paymentRequest={parameterService.getGooglePaymentRequest()}
                            className={this.state.canMakeGooglePayments && this.state.selectedPayment === 'googlepay' ? " active" : null}
                            onLoadPaymentData={this.onLoadPaymentData}
                            onReadyToPayChange={this.onReadyToPayChange}
                        />}
                        {(this.state.selectedPayment !== 'applepay' && this.state.selectedPayment !== 'googlepay') && <button type="button" className="btn btn-primary btn-bloc" disabled={!this.state.selectedPayment} onClick={this.onNextClick}>
                            {languageService.texts.next}
                        </button>}
                    </div>
                </div>
            </div>
        );
    }
}

export default PaymentSelection;



// WEBPACK FOOTER //
// ./src/components/PaymentSelection/PaymentSelection.js